<template>
  <el-dialog
    title="放弃费用"
    :visible.sync="visible"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @close="close"
    append-to-body
    width="600px"
  >
  <div style="background: white; padding: 16px;">
    <el-form ref="formRef" :inline="true" :model="formData" :rules="formRules">
      <el-row>
        <el-col :span="24">
          <el-form-item label="放弃原因" prop="apprOpinion">
            <el-input type="textarea" placeholder="请填写放弃原因" :rows="5" v-model="formData.apprOpinion" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button :loading="loading" @click="close">取消</el-button>
      <el-button :loading="loading" type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { giveUpOutlay } from '@/util/api.js'

export default {
  props: {
    visible: false,
    outlayId: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      formData: {},
      formRules: {
        apprOpinion: [{ required: true, message: '请填写放弃原因', trigger: 'blur' }],
      }
    }
  },
  methods: {
    submit () {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          giveUpOutlay({
            ...this.formData,
            outlayId: this.outlayId
          }).then(res => {
            this.loading = false;
            if (res.msgCode == 200) {
              this.$message.success('放弃费用成功！');
              this.$emit('success');
              this.$emit("close");
            } else {
              this.$message.error(res.msg);
            }
          })
        }
      });
    },
    close () {
      this.$emit("close");
    },
  }
}
</script>

<style lang="scss" scoped>
@import 'src/common/form.scss';
</style>


// WEBPACK FOOTER //
// src/pages/outlay/view/OutlayGiveUpDialog.vue